import React, { useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Card,
  CardContent,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  useTheme,
} from "@mui/material";
import { ChevronLeft, ChevronRight, Star } from "@mui/icons-material";
import useMediaQuery from "@mui/material/useMediaQuery";
import SwipeableViews from "react-swipeable-views";

const testimonials = [
  {
    name: "Harish T",
    title: "Madhapur branch",
    text: "I have recently got my alloy custom painting job done here at the Madhapur branch. I got very good assistance from Sandeep from GoClutch...",
  },
  {
    name: "Ram Knock",
    title: "Hyderabad",
    text: "Sandeep and his staff are too good, blindly you guys can trust this service. Amazing response and hassle-free solutions...",
  },
  {
    name: "Anudeep Pinnamaneni",
    title: "Hyderabad",
    text: "The GoClutch guys are very experienced; they pick up the car, service it, and share photos & videos on WhatsApp. Highly recommended...",
  },
  {
    name: "Kathik",
    title: "Hyderabad",
    text: "I recently had my car serviced at GoClutch, and I must say I'm very pleased with the experience. Great service at a reasonable cost...",
  },
  {
    name: "Dr. Greevani Prasad Vasireddy",
    title: "Hyderabad",
    text: "Had a great experience. My car had a major dent, and they restored it perfectly! Thanks to GoClutch for their excellent work...",
  },
];

const TestimonialSlider = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [activeStep, setActiveStep] = useState(0);
  const [open, setOpen] = useState(false);
  const [selectedTestimonial, setSelectedTestimonial] = useState(null);
  const maxSteps = testimonials.length;

  const handleNext = () => setActiveStep((prev) => (prev < maxSteps - 1 ? prev + 1 : 0));
  const handleBack = () => setActiveStep((prev) => (prev > 0 ? prev - 1 : maxSteps - 1));
  const handleOpenModal = (testimonial) => {
    setSelectedTestimonial(testimonial);
    setOpen(true);
  };
  const handleCloseModal = () => setOpen(false);

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "900px",
        mx: "auto",
        py: 5,
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
          mb: 3,
        }}
      >
        <Star sx={{ color: "gold", fontSize: isMobile ? "1.8rem" : "2.2rem" }} />
        <Typography
          variant={isMobile ? "h5" : "h4"}
          sx={{
            fontWeight: "bold",
            color: "#222",
            textAlign: "center",
            whiteSpace: "nowrap",
          }}
        >
          Why Our Customers Love
        </Typography>
      </Box>

      <Box
        sx={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        <IconButton
          onClick={handleBack}
          sx={{
            position: "absolute",
            left: 0,
            zIndex: 2,
            background: "orangered",
            color: "white",
            "&:hover": { background: "#cc3300" },
            display: isMobile ? "none" : "flex",
          }}
        >
          <ChevronLeft />
        </IconButton>

        <SwipeableViews
          index={activeStep}
          onChangeIndex={(index) => setActiveStep(index)}
          enableMouseEvents
          style={{ width: "100%", overflow: "hidden" }}
        >
          {testimonials.map((testimonial, index) => (
            <Box key={index} sx={{ px: isMobile ? 2 : 5 }}>
              <Card
                elevation={4}
                sx={{
                  p: 3,
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                  borderRadius: 2,
                  textAlign: "left",
                  mx: "auto",
                  maxWidth: isMobile ? "100%" : "70%",
                  transition: "transform 0.3s",
                  "&:hover": { transform: "scale(1.02)" },
                  overflow: "hidden",
                }}
              >
                <CardContent>
                  <Typography variant="h5" sx={{ fontWeight: "bold", color: "orangered" }}>
                    {testimonial.name}
                  </Typography>
                  <Typography color="text.secondary" sx={{ fontSize: "1rem", mb: 1 }}>
                    {testimonial.title}
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: "1rem", color: "#444", mb: 2 }}>
                    {testimonial.text.length > 120
                      ? testimonial.text.substring(0, 120) + "..."
                      : testimonial.text}
                  </Typography>
                  <Button
                    size="small"
                    onClick={() => handleOpenModal(testimonial)}
                    sx={{
                      color: "#1976d2",
                      fontWeight: "bold",
                      textTransform: "uppercase",
                    }}
                  >
                    View More
                  </Button>
                </CardContent>
              </Card>
            </Box>
          ))}
        </SwipeableViews>

        <IconButton
          onClick={handleNext}
          sx={{
            position: "absolute",
            right: 0,
            zIndex: 2,
            background: "orangered",
            color: "white",
            "&:hover": { background: "#cc3300" },
            display: isMobile ? "none" : "flex",
          }}
        >
          <ChevronRight />
        </IconButton>
      </Box>

      <Box sx={{ mt: 3, display: "flex", justifyContent: "center" }}>
        {testimonials.map((_, index) => (
          <Box
            key={index}
            sx={{
              width: activeStep === index ? 14 : 8,
              height: activeStep === index ? 14 : 8,
              borderRadius: "50%",
              backgroundColor: activeStep === index ? "orangered" : "#ddd",
              margin: "0 5px",
              transition: "all 0.3s ease-in-out",
            }}
          />
        ))}
      </Box>

      {/* View More Modal */}
      <Dialog open={open} onClose={handleCloseModal} fullWidth maxWidth="sm">
        <DialogTitle>{selectedTestimonial?.name}</DialogTitle>
        <DialogContent dividers>
          <Typography variant="subtitle1" color="text.secondary" gutterBottom>
            {selectedTestimonial?.title}
          </Typography>
          <Typography variant="body1">{selectedTestimonial?.text}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default TestimonialSlider;
